<script>
	import Router from "svelte-spa-router";
	import { wrap } from "svelte-spa-router/wrap";

	import WidgetTable from "./WidgetTable.svelte";
	import PurchasePreview from "./PurchasePreview.svelte";
	import PurchaseCustom from "./PurchaseCustom.svelte";

	export let product;

	const routes = {
		"/": wrap({
			component: WidgetTable,
			props: { product },
		}),
		"/preview-pack/custom/:product?": wrap({
			component: PurchaseCustom,
		}),
		"/preview-pack/:name": wrap({
			component: PurchasePreview,
			conditions: detail => {
				return detail.params !== "custom";
			},
		}),
	};
</script>

<Router {routes} />
